import React, { useState } from "react";
import Input from "./InputYeni";
import Checkbox2 from "./Checkbox2";
import Button from "./Button";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "../../redux/actions";

const Giris = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.auth);
  const [rememberMe, setRememberMe] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const loginData = Object.fromEntries(formData.entries());
    loginData.rememberMe = rememberMe;

    try {
      const result = await dispatch(loginUser(loginData)).unwrap();
      if (result.accessToken) {
        navigate("/");
      }
    } catch (error) {
      // Redux state'i otomatik güncellenecek
    }
  };

  const handleCheckboxChange = (checked) => {
    setRememberMe(checked);
  };

  return (
    <div className="containerMain grid grid-cols-1 mx-auto place-items-center h-auto my-28">
      <form className="form-container" onSubmit={handleSubmit}>
        <div className="w-[80%] grid place-items-center my-3 ">
          <img src="/logo.svg" alt="logo" className="w-full border-b-2 pb-5" />
        </div>
        <Input page="giris" />
        <Checkbox2 checked={rememberMe} onChange={handleCheckboxChange} />
        <Button page="giris" loading={loading} />
        {error && (
          <div className="p-1 text-red-500">
            <p className="text-center">{error}</p>
          </div>
        )}
      </form>
    </div>
  );
};

export default Giris;
